import { useState } from 'react';
import { Link } from '@tanstack/react-router';
import { MdAdd, MdArrowDropDown } from 'react-icons/md';
import { Button } from '@/components/Button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import CandidatesResumeUploadModal from './CandidatesResumeUploadModal';

/**
 * 求職者追加ドロップダウン。
 * 「手動で作成」「CSVを取り込み」「書類から作成」の3つの選択肢を
 * Popover ドロップダウンで提供する。
 */
export default function CandidatesAddDropdown() {
  // ドロップダウンの開閉状態
  const [isOpen, setIsOpen] = useState(false);
  // 書類から作成モーダルの開閉状態
  const [isResumeModalOpen, setIsResumeModalOpen] = useState(false);

  /** 共通のリンクスタイル（求人管理のドロップダウンと同じスタイルを踏襲） */
  const linkClassName =
    'flex items-center gap-2 px-4 py-3 text-sm text-gray-700 no-underline hover:bg-gray-50 hover:text-gray-700';

  return (
    <>
      <Popover open={isOpen} onOpenChange={setIsOpen} modal>
        <PopoverTrigger asChild>
          <Button color="primary" size="md" active={isOpen}>
            <MdAdd className="size-icon-sm" />
            求職者を追加
            <MdArrowDropDown
              className={`size-icon-xs transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
            />
          </Button>
        </PopoverTrigger>
        <PopoverContent align="end" className="rounded-sm bg-white p-0">
          <div className="flex flex-col">
            {/* 手動で作成 */}
            <Link
              to="/agent/candidates/new"
              className={linkClassName}
              onClick={() => setIsOpen(false)}
            >
              手動で登録
            </Link>
            {/* CSVを取り込み */}
            <Link
              to="/agent/candidates/candidate_import_requests/new"
              className={linkClassName}
              onClick={() => setIsOpen(false)}
            >
              CSVで一括登録
            </Link>
            {/* 書類から作成 */}
            <button
              type="button"
              className={linkClassName}
              onClick={() => {
                setIsOpen(false);
                setIsResumeModalOpen(true);
              }}
            >
              ファイルから登録
            </button>
          </div>
        </PopoverContent>
      </Popover>

      {/* 書類から作成モーダル（Popover の外側に配置して独立して制御する） */}
      <CandidatesResumeUploadModal
        isOpen={isResumeModalOpen}
        onClose={() => setIsResumeModalOpen(false)}
      />
    </>
  );
}
